const API_URL = 'https://blog-api.multdesk.com.br/api';

export const blogService = {
    // Get all blogs
    getAllBlogs: async () => {
        const response = await fetch(`${API_URL}/blogs`);
        if (!response.ok) {
            throw new Error('Failed to fetch blogs');
        }
        return response.json();
    },

    // Get single blog
    getBlog: async (id) => {
        const response = await fetch(`${API_URL}/blogs/${id}`);
        if (!response.ok) {
            throw new Error('Failed to fetch blog');
        }
        return response.json();
    },

    // Create new blog
    createBlog: async (blogData) => {
        const response = await fetch(`${API_URL}/blogs`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(blogData),
        });
        if (!response.ok) {
            throw new Error('Failed to create blog');
        }
        return response.json();
    },

    // Update blog
    updateBlog: async (id, blogData) => {
        const response = await fetch(`${API_URL}/blogs/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(blogData),
        });
        if (!response.ok) {
            throw new Error('Failed to update blog');
        }
        return response.json();
    },

    // Delete blog
    deleteBlog: async (id) => {
        const response = await fetch(`${API_URL}/blogs/${id}`, {
            method: 'DELETE',
        });
        if (!response.ok) {
            throw new Error('Failed to delete blog');
        }
        return response.json();
    },
}; 